require('jquery');
require('jquery-validation');
require('jquery-validation-unobtrusive');
require('bootstrap-datepicker');
require('html5shiv');

window.onloadCustomerCallback = function () {
    if (typeof (document.getElementById('recaptcha-contact')) !== 'undefined' && document.getElementById('recaptcha-contact') !== null) {
        var widgetId1 = grecaptcha.render('recaptcha-contact', {
            'sitekey': "6LddUywUAAAAAOCTG4tDdcbJv5VSVEbCKZVhu-6c",
            'theme': 'light'
        });
    }
    window.recaptchaContact = widgetId1;
}

$(document).ready(function () {

    /* Required Fields */
    $('input,select,textarea').each(function () {
        var req = $(this).attr('data-val-required');
        if (undefined !== req) {
            var label = $('label[for="' + $(this).attr('id') + '"]');
            var text = label.text();
            if (text.length > 0) {
                label.append('<span class="requiredInputs">*</span>');
            }
        }
    });

    $("#contactFormSubmit").click(function (e) {
        if (!$('#contactForm').valid()) {
            return false;
        }

        if (!grecaptcha.getResponse(window.recaptchaApplication)) {
            captchaError();
            return false;
        }

        var boolVal = true;

        if (boolVal) {
            //preloader
            var loader = "<div class='loader-wrapper title'><div class='loader-content align-center'><h1>Sending...</h1></div><div class='loader large'></div><div class='loader-section section-left'></div><div class='loader-section section-right'></div></div>";
            $(".container-uhm").before(loader);
            var handle = window.setTimeout(function () {
                $('.loader-wrapper.title').addClass('loaded');
            }, 50000);

            return true;
        }
        return false;
    });

    /* Formats all phone number inputs */
    $('input[type="tel"]').on('input', function () {
        var number = $(this).val().replace(/[^\d]/g, '');

        if ((number.length + 1) > 10) {
            number = number.substring(0, 10);
        }

        if (number.length === 3) {
            number = number.replace(/(\d{3})/, "$1");
        }
        if (number.length === 7) {
            number = number.replace(/(\d{3})(\d{4})/, "$1-$2");
        } else if (number.length === 10) {
            number = number.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

        }
        $(this).val(number);
    });

    $("#PhoneNumber").attr({ placeholder: '(___) ___-____' });

    $('#Name').on('input', function (e) {

        var userName = $(this).val().replace(/^[\d\s\-]/g, '');
        userName = userName.replace(/[^a-zA-Z\s\-]/g, '');

        if (!/^[a-zA-Z][a-zA-Z\s\-]*/i.test(userName)) {
            $(this).parent().find(".errorMessage").html("Only letters are allowed.");
        }
        else {
            $(this).parent().find(".errorMessage").html("");
        }

        $(this).val(userName);

    });

    if ($('#WorkshopSignUp').length > 0) {
        workshopCheckbox();

        $('#WorkshopSignUp').on('change', function (e) {
            workshopCheckbox();
        });
    }

    function workshopCheckbox() {
        if ($('#WorkshopSignUp').is(':checked')) {
            $('#workshopSignUp').css('display', 'block');
        }
        else {
            $('#workshopSignUp').css('display', 'none');
        }
    }
});